import styled from "styled-components";
import { ScenarioInfo } from "./ScenarioInfo";
import { Prerequisites } from "./Prerequisites";
import { GenerateSolutionDialog } from "@opstel/dialogs/GenerateSolutionDialog/GenerateSolutionDialog";
import { useCurrentInstanceMetadata } from "@shared/common/contexts/instanceMetadata/useCurrentInstanceMetadata";
import { SendToDonnaDialog } from "@opstel/dialogs/SendToDonna/SendToDonnaDialog";
import { ConflictSidePanelWrapper } from "@opstel/Conflicts/ConflictSidePanelWrapper";

export function SidePanel(): React.JSX.Element {
  const { data: instanceMetadata } = useCurrentInstanceMetadata();
  return (
    <tractie-side-panel collapsible="open">
      <SidePanelContainer>
        <ScenarioInfo instanceMetadata={instanceMetadata} />
        <SendToDonnaDialog />
        <Prerequisites />
        <GenerateSolutionDialog />
        <ConflictSidePanelWrapper />
      </SidePanelContainer>
    </tractie-side-panel>
  );
}

const SidePanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.spacing6.toString()};
  height: auto;
  overflow: auto;

  h2 {
    font-size: var(--tractie-typography-size-m);
    font-weight: var(--tractie-typography-weight-medium);
    margin-top: 0;
    margin-bottom: var(--tractie-spacing-inset-xs);
  }
`;
